import styled from '@emotion/styled/macro'
import mediaQuery from 'share/utils/mediaQuery'

import { pageContentDefaultSize } from 'style/emotion'

const CourseInstructionsContainer = styled('section')`
  ${pageContentDefaultSize}

  color: var(--CINight);

  > h2 {
    margin-bottom: 24px;
    margin-top: 48px;

    ${mediaQuery('tablet')} {
      margin-top: 24px;
    }
  }
`

const CourseInstructionsContent = styled('div')`
  color: var(--print-secondary);
  margin-bottom: 24px;

  > :last-child {
    margin-bottom: 0;
  }
`

export { CourseInstructionsContainer, CourseInstructionsContent }
